module.exports = __webpack_public_path__ + "img/me-photo-sm.1f21403e.jpg";